export default class ContactDetails {
  /** @type {string} */ Telephone = null
  /** @type {string} */ TeleFax = null
  /** @type {string} */ WebAddress = null
  /** @type {string} */ ElectronicMail = null
  /** @type {string} */ INETownCode = null
  /** @type {string} */ ContactPersons = null
  /** @type {string} */ CnoCnae = null
  /** @type {string} */ AdditionalDetails = null
}
